
export enum PickupTypeCd {
	DT = 'DT',
	HE = 'HE',
	HL = 'HL',
	PU = 'PU',
	SE = 'SE'}

